// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  environment: 'development',
  firebase: {
    apiKey: "AIzaSyAUnCrKFZdGwN5fCyXYPOEVYEiuaYTgqis",
    authDomain: "height-clinic.firebaseapp.com",
    projectId: "height-clinic",
    storageBucket: "height-clinic.firebasestorage.app",
    messagingSenderId: "651093122529",
    appId: "1:651093122529:web:45daa6859a38472c31c6a0",
    measurementId: "G-070BXYGFXR"
  },
  // Add reCAPTCHA specific settings for development
  recaptcha: {
    siteKey: "", // Add your reCAPTCHA site key here if needed
    enabled: true
  },
  // Razorpay configuration (do not store secret in frontend)
  // Keep only public key_id here if needed; secret must stay in backend
  razorpay: {
    key: "rzp_live_RYwwGPbKCjHYwt"
  },
  // Firebase Functions configuration
  firebaseFunctions: {
    region: 'asia-south1',
    projectId: 'height-clinic'
  },
  // Shiprocket configuration
  shiprocket: {
    baseUrl: 'https://apiv2.shiprocket.in/v1/external',
    // Warehouse/pickup address details (required for Shiprocket)
    warehouse: {
      name: 'Warehouse',
      phone: '+919890446677', // Primary warehouse phone number
      email: 'gauravnik97@gmail.com', // Warehouse email (can use API email or different)
      address: '1, dr piyu height clinic, chavan galli, Opposite to panchayat, Gokul Shirgaon, Opposite to panchayat, Kolhapur, Maharashtra, India, 416234',
      addressLine2: '',
      city: 'Kolhapur',
      state: 'Maharashtra',
      country: 'India',
      pincode: '416234', // Warehouse pincode
      lat: 16.6440249,
      long: 74.2744895
    }
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
